module.exports = __webpack_public_path__ + "static/4-0d78d370987954fb6b9f0efec3065e83.woff";